import { render, staticRenderFns } from "./ModalFormRejected.vue?vue&type=template&id=648a6e07&scoped=true&"
import script from "./ModalFormRejected.vue?vue&type=script&lang=js&"
export * from "./ModalFormRejected.vue?vue&type=script&lang=js&"
import style0 from "./ModalFormRejected.vue?vue&type=style&index=0&id=648a6e07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648a6e07",
  null
  
)

export default component.exports